import CartDeleteModal from './CartDeleteModal';

export default CartDeleteModal;
